import styled from 'styled-components'

export const Icon = styled.img`
  display: inline-block;
  margin-right: 0.4rem;
  margin-bottom: -0.2rem;
`
